export const environmentBase = {
  cloudrun: {
    notifyCenter: 'https://aiii-api-notify-center-700749202278.asia-east1.run.app/aiii-api-notify-center',
  },
  apiKey: {
    med: 'AIzaSyD5Q1-FGHUIJKMNJHY6*IKHUJYGTFRD',
    notifyCenter: 'AIzaSyBNbe9Y3j9Cujvqc3S9YXbGgYrT14Emiag',
  },
};
